"use strict";

import { combineEpics } from "redux-observable";

import {
  loginAuthEpic,
  logoutAuthEpic,
  otpConfirmEpic,
  otpResendEpic,
  validateUsernameEpic,
  expiredPasswordChangeValueEpic,
  keyGenerationEpic,
  idleTimeoutEpic,
  forgotUsernameValidateEpic,
  csrfTokenGenEpic,
  changeLanguageEpic,
  forgotUsernameOTPConfirmEpic,
  forgotUsernameOTPResendEpic,
  forgotPasswordValidateEpic,
  forgotPasswordOTPConfirmEpic,
  forgotPasswordOTPResendEpic,
  forgotPasswordAccountConfirmEpic,
  forgotPasswordChangeValueEpic,
} from "./auth.epics";

import {
  settingChangePasscodeEpic,
  getAllAccountsDataEpic,
  getSelectedAccountData,
  changeOperatingType,
  settingGetAllNotificationCategoryEpic,
  settingUpdateNotificationCategoryEpic,
  settingChangePasswordEpic,
  getAllSavingAccountsDataEpic,
  updateDefaultAccountEpic,
  setAccountNickNameEpic,
  settingAuthenticateEpic,
  settingChangePasscodeValidateEpic,
  settingChangePasscodeOTPResendEpic,
  settingChangePasscodeOTPConfirmEpic,
  settingOtpPrefGetTwofaMethodEpic,
  settingOtpPrefGetTwofaRequestOtpEpic,
  settingOtpPrefGetTwofaResendOtpEpic,
  settingOtpPrefGetTwofaConfirmOtpEpic,
  getTransferLimitEpic,
  addTransferLimitEpic,
  getAllCreditCardPreferenceEpic,
  setCreditCardPreferenceEpic,
  getNotificationCategoriesDataEpic,
  updateNotificationCategoryEpic,
} from "./setting.epics";
import {
  accountListsEpic,
  accountDetailsEpic,
  ePassbookListEpic,
  accountHistoryListEpic,
  eligibleListEpic,
  savingAccountsOpenInitiateEpic,
  savingAccountsOtpResendEpic,
  savingAccountsOtpConfirmationEpic,
  savingAccountsReceiptEpic,
  downloadAccountStatementEpic,
} from "./account.epics";
import {
  dashboardAccountHistoryListEpic,
  dashboardAccountListsEpic,
  dashboardBannerListsEpic,
  dashboardSecureMailNotificationEpic,
} from "./dashboard.epics";
import {
  getProfileDetailsEpic,
  updateProfilePictureEpic,
  getProfileNicknameUpdateEpic,
} from "./profile.epics";
import { loansActivityListsEpic, loansListsEpic } from "./loans.epics";
import {
  fixedDeposiReceiptEpic,
  fixedDepositOtpConfirmationEpic,
  fixedDepositOtpResendEpic,
  fixedDepositsEligibleCasaListEpic,
  fixedDepositsListEpic,
  fixedDepositsOpenInitiateEpic,
  fixedDepositsProductDetailsEpic,
  fixedDepositsRateListEpic,
} from "./fixedDeposits.epics";
import {
  creditCardCashbackDetailsEpic,
  creditCardStatementDetailsEpic,
  creditCardStatementListsEpic,
  creditCardSupplementaryDetailsEpic,
  creditCardTransactionListsEpic,
  debitCardDetailsEpic,
  debitCardTransactionHistoryEpic,
} from "./creditCard.epics";

import {
  creditCardResendEpic,
  optConfirmationEpic,
  payBillEpic,
  payeeTypesListEpic,
  payFromListEpic,
  payToBanksListEpic,
  validateAmountEpic,
  validateDfccOtherCreditCardEpic,
} from "./creditCardPayments.epics";

import {
  optConfirmationBillEpic,
  payableListEpic,
  payBillGeneralEpic,
  payeeCategoriesListEpic,
  payeeTypesGeneralListEpic,
  resendOtpEpic,
  validateBillAccountNumberEpic,
  validateBillAmountEpic,
} from "./generalBillPayments.epics";
import {
  addToFavouritesEpic,
  deleteFavouriteEpic,
  favouriteOutstadingAmountEpic,
  favouritePayEpic,
  favouriteResendOtpEpic,
  favouritesPayableListEpic,
  favouriteTransactionHistoryDetailsEpic,
  favouriteTransactionHistoryListEpic,
  getFavouritesDetailsEpic,
  getFavouritesListEpic,
  getRecentFavouritesListEpic,
  updateFavouriteEpic,
  updateFavouriteOtpConfirmationEpic,
  validateFavouriteAmountEpic,
} from "./favourites.epics";
import {
  fundTransferCurrencyConvertionEpic,
  fundTransferInitializeEpic,
  fundTransferOTPEpic,
  fundTransferpayBankListEpic,
  fundTransferpayFromListEpic,
  fundTransferpayToListEpic,
  fundTransferProceedEpic,
  fundTransferValidateAccountDetailsEpic,
} from "./fundTransfer.epics";
import {
  transactionHistoryListEpic,
  transactionHistoryDetailsEpic,
} from "./history.epics";
import {
  addProfileDataEpic,
  backOfficeValidationEpic,
  debitCardInitRegisterEpic,
  debitCardPreRegisterEpic,
  nicValidateEpic,
  onboardingOtpConfirmEpic,
  onboardingOtpResendEpic,
  onboardingUsernameValidateEpic,
} from "./onboarding.epics";
import {
  serviceRequestAssetsOptionsEpic,
  serviceRequestCancelEpic,
  serviceRequestDetailEpic,
  serviceRequestFilterDataEpic,
  serviceRequestInitiateEpic,
  serviceRequestListEpic,
  serviceRequestOtpEpic,
  serviceRequestResendOtpEpic,
  serviceRequestTemplateCategoriesListsEpic,
  serviceRequestTemplateFieldsEpic,
  serviceRequestTemplateListsEpic,
  serviceRequestValidateEpic,
} from "./serviceReqeust.epics";
import { accountSummaryListsEpic } from "./portfolio.epics";
import {
  secureEmailSendInitiateEpic,
  secureEmailSendMailEpic,
  secureEmailSaveToDraftEpic,
  secureMailGettListEpic,
  secureMailDeleteMailEpic,
  secureMailMessageListMailEpic,
  secureMailReplyEpic,
  secureMailSingleNotifyEpic,
  secureMailNotifyEpic,
  secureMailFileUploadEpic,
  secureMailFileDeleteEpic,
  secureMailFileDownloadEpic,
  secureMailSendOtpEpic,
  secureMailResendOtpEpic,
  secureMailMessageClosedEpic,
} from "./secureEmail.epics";

import {
  notificationListsEpic,
  notificationDetailsEpic,
  notificationUpdateEpic,
  notificationUnreadCountEpic,
} from "./notification.epics";
import {
  finesListEpic,
  policeStationListEpic,
  trafficFinePayableListEpic,
  trafficFineValidateAmountEpic,
  trafficFinePayBillEpic,
  trafficFineOtpConfirmEpic,
  trafficFineOtpResendEpic,
} from "./trafficFine.epics";
import {
  changeIterationStatusEpic,
  scheduleIterationListEpic,
  schedulePaymentsListEpic,
  stopSchedulePaymentEpic,
} from "./schedulePayments";

export default combineEpics(
  keyGenerationEpic,
  loginAuthEpic,
  logoutAuthEpic,
  idleTimeoutEpic,
  otpConfirmEpic,
  otpResendEpic,
  expiredPasswordChangeValueEpic,
  changeLanguageEpic,

  // settings
  getAllAccountsDataEpic,
  getSelectedAccountData,
  changeOperatingType,
  settingChangePasscodeEpic,
  settingChangePasswordEpic,
  getAllSavingAccountsDataEpic,
  updateDefaultAccountEpic,
  setAccountNickNameEpic,
  settingAuthenticateEpic,
  settingChangePasscodeValidateEpic,
  settingChangePasscodeOTPResendEpic,
  settingChangePasscodeOTPConfirmEpic,
  settingOtpPrefGetTwofaMethodEpic,
  settingOtpPrefGetTwofaRequestOtpEpic,
  settingOtpPrefGetTwofaResendOtpEpic,
  settingOtpPrefGetTwofaConfirmOtpEpic,
  getAllCreditCardPreferenceEpic,
  setCreditCardPreferenceEpic,
  getNotificationCategoriesDataEpic,
  updateNotificationCategoryEpic,
  // dfcc dashboard

  dashboardAccountListsEpic,
  dashboardBannerListsEpic,
  dashboardAccountHistoryListEpic,
  dashboardSecureMailNotificationEpic,

  // fixed deposits
  fixedDepositsListEpic,
  fixedDepositsRateListEpic,
  fixedDepositsEligibleCasaListEpic,
  fixedDepositsProductDetailsEpic,
  fixedDepositsOpenInitiateEpic,
  fixedDepositOtpConfirmationEpic,
  fixedDepositOtpResendEpic,
  fixedDeposiReceiptEpic,

  // profile
  getProfileDetailsEpic,
  updateProfilePictureEpic,
  getProfileNicknameUpdateEpic,

  //forgot username flow
  forgotUsernameValidateEpic,
  csrfTokenGenEpic,

  //Accounts
  accountListsEpic,
  accountDetailsEpic,
  ePassbookListEpic,
  accountHistoryListEpic,
  downloadAccountStatementEpic,

  //forgot password
  forgotUsernameOTPConfirmEpic,
  forgotUsernameOTPResendEpic,
  forgotPasswordValidateEpic,
  forgotPasswordOTPConfirmEpic,
  forgotPasswordOTPResendEpic,
  forgotPasswordAccountConfirmEpic,
  forgotPasswordChangeValueEpic,

  //Credit Card
  creditCardCashbackDetailsEpic,
  creditCardTransactionListsEpic,
  creditCardStatementListsEpic,
  creditCardStatementDetailsEpic,
  creditCardSupplementaryDetailsEpic,
  debitCardDetailsEpic,
  debitCardTransactionHistoryEpic,

  // loans
  loansListsEpic,
  loansActivityListsEpic,
  creditCardResendEpic,
  //creditcard bill payments

  validateDfccOtherCreditCardEpic,
  payFromListEpic,
  validateAmountEpic,
  payBillEpic,
  payeeTypesListEpic,
  payToBanksListEpic,
  optConfirmationEpic,

  // generl bill payments
  payeeCategoriesListEpic,
  payeeTypesGeneralListEpic,
  payableListEpic,
  validateBillAccountNumberEpic,
  validateBillAmountEpic,
  payBillGeneralEpic,
  optConfirmationBillEpic,
  resendOtpEpic,

  // favourites
  getFavouritesListEpic,
  addToFavouritesEpic,
  getRecentFavouritesListEpic,
  favouritesPayableListEpic,
  validateFavouriteAmountEpic,
  favouritePayEpic,
  getFavouritesDetailsEpic,
  favouriteOutstadingAmountEpic,
  updateFavouriteEpic,
  updateFavouriteOtpConfirmationEpic,
  deleteFavouriteEpic,
  favouriteTransactionHistoryListEpic,
  favouriteTransactionHistoryDetailsEpic,
  favouriteResendOtpEpic,

  //fundTransfer
  fundTransferpayFromListEpic,
  fundTransferpayToListEpic,
  fundTransferCurrencyConvertionEpic,
  fundTransferInitializeEpic,
  fundTransferOTPEpic,
  fundTransferProceedEpic,
  fundTransferpayBankListEpic,
  fundTransferValidateAccountDetailsEpic,

  //history
  transactionHistoryListEpic,
  transactionHistoryDetailsEpic,

  //setting
  getTransferLimitEpic,
  addTransferLimitEpic,

  // onboarding
  nicValidateEpic,
  debitCardPreRegisterEpic,
  debitCardInitRegisterEpic,
  onboardingOtpResendEpic,
  onboardingOtpConfirmEpic,
  onboardingUsernameValidateEpic,
  backOfficeValidationEpic,
  addProfileDataEpic,

  //myPortfolio
  accountSummaryListsEpic,

  //notification
  notificationListsEpic,
  notificationDetailsEpic,
  notificationUpdateEpic,
  notificationUnreadCountEpic,
  //saving account opening
  eligibleListEpic,
  savingAccountsOpenInitiateEpic,
  savingAccountsOtpResendEpic,
  savingAccountsOtpConfirmationEpic,
  savingAccountsReceiptEpic,
  // service request
  serviceRequestTemplateCategoriesListsEpic,
  serviceRequestTemplateListsEpic,
  serviceRequestTemplateFieldsEpic,
  serviceRequestAssetsOptionsEpic,
  serviceRequestValidateEpic,
  serviceRequestInitiateEpic,
  serviceRequestOtpEpic,
  serviceRequestResendOtpEpic,
  serviceRequestListEpic,
  serviceRequestFilterDataEpic,
  serviceRequestDetailEpic,
  serviceRequestCancelEpic,

  //secureMail
  secureEmailSendInitiateEpic,
  secureEmailSendMailEpic,
  secureEmailSaveToDraftEpic,
  secureMailGettListEpic,
  secureMailDeleteMailEpic,
  secureMailMessageListMailEpic,
  secureMailReplyEpic,
  secureMailSingleNotifyEpic,
  secureMailNotifyEpic,
  secureMailFileUploadEpic,
  secureMailFileDeleteEpic,
  secureMailFileDownloadEpic,
  secureMailSendOtpEpic,
  secureMailResendOtpEpic,
  secureMailMessageClosedEpic,

  // traffic fines

  policeStationListEpic,
  finesListEpic,
  trafficFinePayableListEpic,
  trafficFineValidateAmountEpic,
  trafficFinePayBillEpic,
  trafficFineOtpConfirmEpic,
  trafficFineOtpResendEpic,

  //schedulePayments
  schedulePaymentsListEpic,
  changeIterationStatusEpic,
  scheduleIterationListEpic,
  stopSchedulePaymentEpic,
);
